import React, { useEffect } from 'react'
import Layout from '../layout/Layout'
import MessagesSvg from '../other/svg/MessagesSvg'
import { useTranslation } from 'react-i18next'
import { FETCH_CONVERSATIONS } from 'dealer-reducers'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import FlatList from '../molecules/FlatList'
import { ListConversation } from 'dealer-types'
import ConversationItem from '../molecules/ConversationItem'

const Conversations = (): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { conversations } = useSelector((state: RootReducer) => state.conversationsListReducer)
  useEffect(() => {
    if (conversations.length === 0) {
      dispatch(FETCH_CONVERSATIONS({}))
    }
  }, [dispatch, conversations])
  return (
    <Layout
      withoutToolbar={false}
      iconComponent={<MessagesSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      name={t('messages')}>
      <div className="h-[calc(100vh-200px)]">
        <FlatList
          data={conversations}
          component={(itemProps: ListConversation) => <ConversationItem {...itemProps} />}
          // eslint-disable-next-line require-await
          fetchMore={async () => {
            dispatch(FETCH_CONVERSATIONS({}))
            // eslint-disable-next-line @typescript-eslint/return-await
            return Promise.resolve()
          }}
          itemMinWidth={'100%'}
        />
      </div>
    </Layout>
  )
}

export default Conversations
